export default [
  {
    layerSelectors: [
      '.js-path1',
      '.js-path1_layer4',
      '.js-path1_layer3',
      '.js-path1_layer2'
    ]
  },
  {
    layerSelectors: [
      '.js-path1_sp',
      '.js-path1_sp_layer3',
      '.js-path1_sp_layer4',
      '.js-path1_sp_layer2'
    ],
    loopReverse: false
  },
  {
    layerSelectors: [
      '.js-path2_sp',
      '.js-path2_sp_layer3',
      '.js-path2_sp_layer4',
      '.js-path2_sp_layer1'
    ],
    loopReverse: false
  },
  {
    layerSelectors: [
      '.js-path3_sp',
      '.js-path3_sp_layer1',
      '.js-path3_sp_layer2',
      '.js-path3_sp_layer4'
    ],
    loopReverse: true
  },
  {
    layerSelectors: [
      '.js-path4_sp',
      '.js-path4_sp_layer1',
      '.js-path4_sp_layer3',
      '.js-path4_sp_layer2'
    ],
    loopReverse: false
  },
  {
    layerSelectors: [
      '.js-path5_sp',
      '.js-path5_sp_layer2',
      '.js-path5_sp_layer3',
      '.js-path5_sp_layer4'
    ],
    loopReverse: false
  },
  {
    layerSelectors: [
      '.js-path6_sp',
      '.js-path6_sp_layer2',
      '.js-path6_sp_layer3',
      '.js-path6_sp_layer4'
    ],
    loopReverse: false
  },
  {
    layerSelectors: [
      '.js-path7_sp',
      '.js-path7_sp_layer4',
      '.js-path7_sp_layer3',
      '.js-path7_sp_layer2'
    ],
    loopReverse: false
  },
  {
    layerSelectors: [
      '.js-path8_sp',
      '.js-path8_sp_layer2',
      '.js-path8_sp_layer4',
      '.js-path8_sp_layer3'
    ],
    loopReverse: false
  },
  {
    layerSelectors: [
      '.js-path2',
      '.js-path2_layer1',
      '.js-path2_layer4',
      '.js-path2_layer3'
    ],
    loopReverse: true
  },
  {
    layerSelectors: [
      '.js-path3',
      '.js-path3_layer2',
      '.js-path3_layer1',
      '.js-path3_layer4'
    ],
    loopReverse: false
  },
  {
    layerSelectors: [
      '.js-path4',
      '.js-path4_layer3',
      '.js-path4_layer2',
      '.js-path4_layer1'
    ],
    loopReverse: false
  },
  {
    layerSelectors: [
      '.js-path5',
      '.js-path5_layer10',
      '.js-path5_layer9',
      '.js-path5_layer8',
      '.js-path5_layer7',
      '.js-path5_layer6'
    ]
  },
  {
    layerSelectors: [
      '.js-path6',
      '.js-path6_layer5',
      '.js-path6_layer10',
      '.js-path6_layer9',
      '.js-path6_layer8',
      '.js-path6_layer7'
    ]
  },
  {
    layerSelectors: [
      '.js-path7',
      '.js-path7_layer6',
      '.js-path7_layer5',
      '.js-path7_layer10',
      '.js-path7_layer9',
      '.js-path7_layer8'
    ]
  },
  {
    layerSelectors: [
      '.js-path8',
      '.js-path8_layer7',
      '.js-path8_layer6',
      '.js-path8_layer5',
      '.js-path8_layer10',
      '.js-path8_layer9'
    ],
    loopReverse: false
  },
  {
    layerSelectors: [
      '.js-path9',
      '.js-path9_layer8',
      '.js-path9_layer7',
      '.js-path9_layer6',
      '.js-path9_layer5',
      '.js-path9_layer10'
    ],
    loopReverse: false
  },
  {
    layerSelectors: [
      '.js-path10',
      '.js-path10_layer9',
      '.js-path10_layer8',
      '.js-path10_layer7',
      '.js-path10_layer6',
      '.js-path10_layer5'
    ],
    loopReverse: true
  },
  {
    layerSelectors: [
      '.js-path11',
      '.js-path11_layer18',
      '.js-path11_layer17',
      '.js-path11_layer16',
      '.js-path11_layer15',
      '.js-path11_layer14',
      '.js-path11_layer13',
      '.js-path11_layer12'
    ],
    loopReverse: false
  },
  {
    layerSelectors: [
      '.js-path12',
      '.js-path12_layer11',
      '.js-path12_layer18',
      '.js-path12_layer17',
      '.js-path12_layer16',
      '.js-path12_layer15',
      '.js-path12_layer14',
      '.js-path12_layer13'
    ],
    loopReverse: false
  },
  {
    layerSelectors: [
      '.js-path13',
      '.js-path13_layer12',
      '.js-path13_layer11',
      '.js-path13_layer18',
      '.js-path13_layer17',
      '.js-path13_layer16',
      '.js-path13_layer15',
      '.js-path13_layer14'
    ],
    loopReverse: false
  },
  {
    layerSelectors: [
      '.js-path14',
      '.js-path14_layer13',
      '.js-path14_layer12',
      '.js-path14_layer11',
      '.js-path14_layer18',
      '.js-path14_layer17',
      '.js-path14_layer16',
      '.js-path14_layer15'
    ],
    loopReverse: true
  },
  {
    layerSelectors: [
      '.js-path15',
      '.js-path15_layer14',
      '.js-path15_layer13',
      '.js-path15_layer12',
      '.js-path15_layer11',
      '.js-path15_layer18',
      '.js-path15_layer17',
      '.js-path15_layer16'
    ],
    loopReverse: false
  },
  {
    layerSelectors: [
      '.js-path16',
      '.js-path16_layer15',
      '.js-path16_layer14',
      '.js-path16_layer13',
      '.js-path16_layer12',
      '.js-path16_layer11',
      '.js-path16_layer18',
      '.js-path16_layer17'
    ],
    loopReverse: false
  },
  {
    layerSelectors: [
      '.js-path17',
      '.js-path17_layer16',
      '.js-path17_layer15',
      '.js-path17_layer14',
      '.js-path17_layer13',
      '.js-path17_layer12',
      '.js-path17_layer11',
      '.js-path17_layer18'
    ],
    loopReverse: true
  },
  {
    layerSelectors: [
      '.js-path18',
      '.js-path18_layer17',
      '.js-path18_layer16',
      '.js-path18_layer15',
      '.js-path18_layer14',
      '.js-path18_layer13',
      '.js-path18_layer12',
      '.js-path18_layer11'
    ],
    loopReverse: false
  }
];
